
export function colorType(c) {
    
   if(c === 'grass') return '#9bcc50'
   if(c === 'poison') return '#b97fc9'
   if(c === 'bug') return '#729f3f'
   if(c === 'fire') return '#fd7d24'
   if(c === 'ground') return '#a74806'
   if(c === 'electric') return '#eed535'
   if(c === 'water') return '#4592c4'
   if(c === 'flying') return '#8cb3cd'
   if(c === 'fairy') return '#ffaec8'
   if(c === 'fighting') return '#ff3a79'
   if(c === 'rock') return '#a38c21'
   if(c === 'steel') return '#9eb7b8'
   if(c === 'psychic') return '#cd6284'
   if(c === 'dark') return '#262525'
   if(c === 'dragon') return '#b00000'
   if(c === 'ice') return '#a8c5c3'
   if(c === 'shadow') return '#656570'
   if(c === 'ghost') return '#7f7f7f'
   if(c === 'normal') return '#a4acaf'
   
   return 'white'
}




